import React from "react";
import { Link } from "react-router-dom";

function Sidebar() {
  return (
    <div className="sidebar">
      <h4 className="text-white mb-4">Farmer Panel</h4>

      <Link to="/dashboard">Dashboard</Link>
      <Link to="/timeline">Timeline</Link>
      <Link to="/checklist">Daily Checklist</Link>
      <Link to="/photos">Photos</Link>
      <Link to="/recommendations">AI Recommendations</Link>
      <Link to="/planner">Planner</Link>
      <Link to="/cloud-sync">Cloud Sync</Link>
      <Link to="/troubleshooting">Troubleshooting</Link>
      <Link to="/support">Support</Link>
      <Link to="/settings">Settings</Link>
    </div>
  );
}

export default Sidebar;